import { z } from "zod";

import { ProjectsLocationsData } from "../../../../../../models/ProjectData";

export const schema = z.object({
  projectJoinDate: z.date()
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (
  projectLocation: ProjectsLocationsData
): Schema => {
  return {
    projectJoinDate: projectLocation.project_join_date
      ? new Date(projectLocation.project_join_date)
      : new Date()
  };
};
